// Avoid re-exports in favor of direct imports or entry-point files

import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const KeyboardShortcutsDialog: LoadableType<any> = LoadableAfterPaint<any>({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-KeyboardShortcutsDialog" */ './NewKeyboardShortcutsDialog.tsx'
			)
		).KeyboardShortcutsDialog;
	},
});
